import { connect } from "react-redux";
import { actions as blogIndexActions } from "./BlogIndex.redux";

import BlogIndex from "./BlogIndex.view";

const mapStateToProps = state => ({
  blogCategories: state.blogCategories,
  blogCategoriesError: state.blogCategoriesError,
  blogCategoriesLoading: state.blogCategoriesLoading,
  targetDevice: state.targetDevice,
});

const mapDispatchToProps = dispatch => ({
  fetchBlogCategories: () => dispatch(blogIndexActions.fetchBlogCategories()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BlogIndex);
